import React, { useContext, useEffect } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'
import moment from 'moment';
import { ReactTinyLink } from 'react-tiny-link'



export default function MessageBoxRemote(data) {
    const { isDark } = useContext(DarkModeContext);

    const isUrl = (string) => {
        var expression  = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

        if(string.match(new RegExp(expression))){
            return true
        }else{
            return false
        }
    }

    useEffect(()=>{
        isUrl(data.data.text);
    }, [])

    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }

    if (data.data.text != "" && data.data.text != "Sent Media")
        return (
            <div className="chat-msg">
                <div className='chat-msg-wrapper-remote'>
                    <img className="chat-remote-user-image" src={data.user.user.image} />
                    <div className={`chat-remote-msg-box ${isDark ? 'chat-dark' : 'chat-light'}`}>
                    {isUrl(data.data.text) ?
                                <ReactTinyLink
                                    cardSize="large"
                                    showGraphic={true}
                                    maxLine={2}
                                    minLine={1}
                                    url={data.data.text}
                                    onError={()=><p>data.data.text</p>}
                                />
                                : data.data.text}
                    </div>
                    <div>

                    </div>
                </div>
                <p className="chat-msg-remote-timestamp">
                    {getTimeAgo(data.data.timestamp)}

                </p>
            </div>
        )

    else
        return (
            <div className="chat-msg">
                <div className='chat-msg-wrapper-remote'>
                    <img className="chat-remote-user-image" src={data.user.user.image} />
                    {data.data.isPaid == 1 ?
                        <div className="msg-paid">
                            {data.data.type.includes('image') ? <img src={data.data.thumbnail} /> : <video autoPlay controls muted src={data.data.thumbnail} />}
                            <div className="price-tag">
                                <img src={require('../../assets/icons/chat_lock.svg')} />
                                <p>${data.data.price}</p>
                            </div>
                        </div>
                        : <div> { data.data.type.includes('image') ? <img src={data.data.media} /> : <video  autoPlay controls muted src={data.data.media} /> }  </div>
                    }
                </div>
                <p className="chat-msg-remote-timestamp">
                    {getTimeAgo(data.data.timestamp)}

                </p>
            </div>
        )

}
